import { defaults } from './defaults.es.js';
var calcDampingRatio = function calcDampingRatio() {
  var stiffness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults.stiffness;
  var damping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaults.damping;
  var mass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaults.mass;
  return damping / (2 * Math.sqrt(stiffness * mass));
};
export { calcDampingRatio };